import {NgModule} from "@angular/core";
import {DateNavigatorComponent} from "./components/date.navigator/date.nav.component";
import {DateInputsModule} from "@progress/kendo-angular-dateinputs";
import {ClickOutModule} from "../ui/directives/click.out/click.out.module";
import {CommonModule} from "@angular/common";
import {PopupModule} from "@progress/kendo-angular-popup";
import {CustomCalendarComponent} from "./components/custom.calendar/custom.calendar.component";
import {CPTranslateModule} from "../translate";
import {DateRangePickerComponent} from "./components/date.range.picker/date.range.picker.component";
import {DateTimeRangePickerComponent} from "./components/datetime.range.picker/datetime.range.picker.component";
import {DateRangePickerCalendarComponent} from "./components/date.range.picker.calendar/date.range.picker.calendar.component";
import {DateTimeEssentialsModule} from "./date.time.essentials.module";
import {DateRangePickerNewComponent} from "./components/date.range.picker.new/date.range.picker.new.component";
import {DateRangeExtendedPickerComponent} from "./components/date.range.extended/date.range.extended.picker.component";
import {NumericTextBoxModule} from "@progress/kendo-angular-inputs";
import {DropDownListModule} from "@progress/kendo-angular-dropdowns";
import {FormsModule} from "@angular/forms";
import {DateTimeExtendedPickerComponent} from "./components/datetime.extended/datetime.extended.picker.control";
import {CheckboxModule} from "../ui/components/checkbox/checkbox.module";
import {HotkeysModule} from "../hotkeys/hotkeys.module";

@NgModule({
	declarations: [DateNavigatorComponent,CustomCalendarComponent,
		DateRangePickerComponent, DateTimeRangePickerComponent, DateRangePickerCalendarComponent, DateRangePickerNewComponent,
		DateRangeExtendedPickerComponent, DateTimeExtendedPickerComponent],
	exports: [DateNavigatorComponent, CustomCalendarComponent,
		DateRangePickerComponent, DateTimeRangePickerComponent, DateRangePickerCalendarComponent, DateRangePickerNewComponent,
		DateRangeExtendedPickerComponent, DateTimeEssentialsModule, DateTimeExtendedPickerComponent],
	imports: [DateInputsModule, ClickOutModule, CommonModule, PopupModule, CPTranslateModule, DateTimeEssentialsModule, NumericTextBoxModule,
		DropDownListModule, FormsModule, CheckboxModule, HotkeysModule],
	providers: []
})
export class DateTimeModule {
}
